import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
class EdStepper extends Vue {
  
  @Prop({ default: true }) showHeader: boolean;
  @Prop({ default: 0 }) currentIndex: number;
  @Prop({}) labels: string[];

  public stepWidth: string = 'width: 0%;';

  get steps() {
    const slotNames = Object.keys(this.$slots).filter(slotName => slotName !== 'default');
    return slotNames.map((name, index) => ({
      label: this.getLabel(index),
      name,
    }));
  }

  get currentSlotName() {
    return this.steps[this.currentIndex]?.name || null;
  }

  get currentSlot() {
    return !!this.currentSlotName;
  }

  calculateStepWidth() {
    if (this.steps.length > 0) {
      let percentage = 100 / this.steps.length;
      this.stepWidth = `width: ${percentage}%;`;  
    }
  }

  getLabel(index: number) {
    if (index < this.labels?.length) {
      return this.labels[index];
    }
    return ''
  }

  /* Hooks */
  mounted() {  
    this.$nextTick(() => {
      this.calculateStepWidth();
    });
  }
}

export default Vue.component('ed-stepper', EdStepper);